import { AdvancedFilterPanel, type FilterField } from '@/components/common/AdvancedFilter';
import { useGeoCascade } from '@/hooks/useGeoCascade';
import type { UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { getDateFromToFilterFields, getGeoFilterFields } from '@/utils/filterFields';
import { FILTER_KEYS, parseNumberFilter } from '@/utils/filters';

const NO_EXTRA_FIELDS: FilterField[] = [];

interface MpAreaFilterPanelProps {
  filters: UrlSyncedFilters;
  personField: FilterField;
  extraFields?: FilterField[] | undefined;
}

export function MpAreaFilterPanel({
  filters,
  personField,
  extraFields = NO_EXTRA_FIELDS,
}: MpAreaFilterPanelProps) {
  const { filterValues, defaultFilterValues, handleFilterChange } = filters;

  const geoOptions = useGeoCascade({
    divisionId: parseNumberFilter(filterValues[FILTER_KEYS.divisionId]),
    districtId: parseNumberFilter(filterValues[FILTER_KEYS.districtId]),
  });

  return (
    <AdvancedFilterPanel
      fields={[
        ...getDateFromToFilterFields(),
        personField,
        ...getGeoFilterFields(filterValues, geoOptions),
        ...extraFields,
      ]}
      values={filterValues}
      defaultValues={defaultFilterValues}
      onChange={handleFilterChange}
    />
  );
}
